import { Language } from "app/shared/enums/languages.enum";

export class Translation {
	field: TranslationField;
	type: TranslationType;
	originalId: number;
	storeId?: number;
	translations: TranslationLang[]
}

export class TranslationLang {
	id?: number;
	value: string;
	default: boolean;
	actionType: TranslationActionType;
	language: Language

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

export enum TranslationField {
	NAME = "NAME",
	DESCRIPTION = "DESCRIPTION"
}

export enum TranslationActionType {
	CREATE = "CREATE", 
	UPDATE = "UPDATE",
	DELETE = "DELETE"
}

export enum TranslationType {
	STORE = "STORE",
	PLACE = "PLACE",
	CATEGORY = "CATEGORY",
	PRODUCT = "PRODUCT", 
	COMPLEMENT = "COMPLEMENT",
	COMPLEMENT_OPTION = "COMPLEMENT_OPTION"
}



// WEBPACK FOOTER //
// ./src/app/shared/models/translation.model.ts